
<div class="card mb-0" style="width: 700px;">
    <div class="card-body" style="padding: 36px 40px">
        <h3 class="card-title-ai">
         AI-Powered Review Replies
        </h3>
        <p class="card-info">
            Harness the power of AI to save valuable time when responding to reviews. Click “Generate Reply” and let our AI bot write the first draft of your review reply.
            You can always edit the reply before you post.
        </p>
        <h3 class="card-subtitle-2">
            Do you want to apply this integration?
        </h3>
        <div class="card-btn">
            <button
             class="btn btn-primary"
              type="button"
              (click)="addOn()"
            >
              Add-On
            </button>
            <button
              class="btn btn-outline-secondary"
              type="button"
              (click)="activeModal.dismiss()"
            >
              Cancel
            </button>
        </div>
    </div>
</div>

<!-- <div class="container">
    <div class="swal2-icon swal2-warning" style="display: flex;">
        <div class="swal2-icon-content">!</div>
      </div>
    <div>
        <h2>
            OpenAI Integration
        </h2>
    </div>
    <div>
        Here is a video demostration of how to use OpenAI
    </div>
    <div class="video-container">
        <iframe 
            width="560" 
            height="315" 
            src="https://www.youtube.com/embed/VSCkrvtVt3Y" 
            style="padding:28px"
            title="YouTube video player" 
            frameborder="0" 
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
            allowfullscreen>
        </iframe>
    </div>
    <div style="margin-bottom: 30px;">
        Do you want to apply this integration?
    </div>
    <div class="button-footer">
        <button 
            class="swal2-confirm swal2-styled"
            (click)="addOn()">
            Add-On
        </button>
        <button 
        class="swal2-cancel swal2-styled"
        (click)="activeModal.dismiss('Cross click')"
        >
            Cancel
        </button>
    </div>
</div> -->